<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form label-width="120px" ref="queryCondition" :model="queryCondition" label-position="right" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="单据编号" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable placeholder="请输入单据编号" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主题" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable placeholder="请输入主题" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入围供应商" prop="supplierName">
                    <el-input class="handle-input" v-model="queryCondition.supplierName" clearable placeholder="入围供应商" suffix-icon="el-icon-search" @click.native='showSelSupplierDialog=true;SupplierNameDialogReset = true' @clear="clearSupplierName" style="width:100%">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="轮次状态" prop="roundStatus">
                    <el-select class="handle-input" v-model="queryCondition.roundStatus" clearable placeholder="轮次状态" style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in roundStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="创建人" prop="buyerName">
                      <el-input class="handle-input" v-model="queryCondition.buyerName" clearable placeholder="请输入创建人" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDate" type="date" clearable placeholder="选择日期" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" clearable :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="非标准线路运费" prop="isSpecialFreight">
                      <el-select v-model="queryCondition.isSpecialFreight" class="handle-input" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value></el-option>
                        <el-option :key="item.key" v-for="item in isSpecialFreightList" :label="item.label" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="8位码" prop="eightBitCodesStr">
                      <el-input v-model="queryCondition.eightBitCodesStr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" clearable class="handle-input" placeholder="请输入8位码" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" type="primary" @click="queryData(1)">查询</el-button>
            <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <div class="action-btn-row">
        <el-button size="mini" class="btn" v-acl="ProductQuoteRoundInit" type="primary" @click="showNewRoundDialogFunc">创建新轮次</el-button>
        <el-button size="mini" class="btn" v-acl="ProductQuoteCloseQuotation" type="primary" @click="endQuotationFunc">结束询价</el-button>
        <el-button size="mini" class="btn" v-acl="ProductQuoteRecoveryQuotation" type="primary" @click="recoveryQuotationFunc">恢复询价</el-button>
        <el-button size="mini" class="btn" v-acl="Sourcing-productQuerySubmit" type="primary" @click="createQuoteConfirmation">创建报价确认</el-button>
        <el-button size="mini" class="btn" v-acl="ProductQuotationHistoryExport" type="primary" @click="onExport">导出</el-button>
      </div>
      <el-table :data="quotationList" border max-height='470' @selection-change="handleSelectionChange" row-key="ttQuotationApplyRoundId" highlight-current-row ref="quotationDataTable">
        <el-table-column align="center" fixed prop="ttQuotationApplyRoundId" :reserve-selection="true" type="selection" width="55" :label="$t('common.select')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="applyNo" label="单据编号" fixed min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.applyNo}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="subject" label="主题" min-width="180px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierNames" label="入围供应商" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundNumber" label="轮次" min-width="80px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationHistory(scope.row.ttQuotationApplyId)">{{scope.row.roundNumber}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundStatusI18n" label="轮次状态" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" label="创建人" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" label="创建日期" min-width="100px"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog el-dialog title="创建新轮次" :before-close="handleClose" :visible.sync="dialogVisible" width="80%">
        <el-form :model="createNewRoundForm" ref="createNewRoundForm" label-width="120px" inline="true">
          <el-form-item label="单据编号:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="主题:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="轮次:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="轮次说明:" prop="documentNumber" size="small">
            <el-input type="textarea" v-model="createNewRoundForm.documentNumber" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="附件:" prop="documentNumber" size="small" style="width:320px">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-change="handleChange" :file-list="fileList">
              <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="mini">提交</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="quotationList" border highlight-current-row class="dialogIntable">
          <el-table-column sortable prop="date" label="供应商编号"></el-table-column>
          <el-table-column sortable prop="name" label="供应商名称"></el-table-column>
          <el-table-column sortable prop="address" label="本轮是否发放"></el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog el-dialog title="询报价详细" :before-close="handleClose" :visible.sync="quotationVisible" width="80%">
        <el-form :model="createNewRoundForm" ref="createNewRoundForm" label-width="120px" inline="true">
          <el-form-item label="单据编号:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="主题:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="创建人:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="创建日期:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
        </el-form>
      </el-dialog>

      <!--新轮次创建-->
      <el-dialog :title="$t('apply.newRound')" :visible.sync="showNewRoundDialog" width="65%">
        <el-form ref="pickupPointForm" class="form_border" :label-position="labelPosition" label-width="120px">
          <div class="handle-box">
            <el-row>
              <el-button size="mini" type="primary" v-acl="ProductQuoteCreateNewRound" @click="saveNewRoundFunc" v-if="showSaveNewRoundFlag">{{$t('common.submit')}}</el-button>
              <!--提交-->
            </el-row>
            <el-form :model="newRoundHeadData" :label-position="labelPosition" ref="newRoundHeadDataForm" label-width="140px">
              <el-row>
                <el-col :span="7">
                  <el-form-item :label="$t('apply.no')">
                    <!--单据编号-->
                    <el-input v-model="newRoundHeadData.applyNo" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :label="$t('apply.subject')">
                    <!--主题-->
                    <el-input v-model="newRoundHeadData.subject" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :label="$t('apply.round')">
                    <!--轮次-->
                    <el-input v-model="newRoundNumber" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="21">
                  <el-form-item :label="$t('apply.roundRemark')">
                    <!--轮次说明-->
                    <el-input type="textarea" v-model="roundRemark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="5">
                <el-col :span="21">
                  <el-form-item :label="$t('common.attachment')" size="small">
                    <!--附件-->
                    <el-upload class="upload-demo" ref="upload" :headers="header" :action="fileUploadUrl" :on-success="uploadSuccess" :on-remove="handleRemove" multiple>
                      <el-button size="mini" type="primary">{{$t('common.selectFile')}}</el-button>
                      <!--选取文件-->
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="5">
                <el-col :span="21">
                  <el-table :data="supplierList" ref="supplierListDataTable" border highlight-current-row>
                    <el-table-column prop="supplierCode" :label="$t('apply.supplierCode')"></el-table-column>
                    <!--供应商编号-->
                    <el-table-column prop="supplierName" :label="$t('apply.supplierName')"></el-table-column>
                    <!--供应商名称-->
                    <!--本轮是否发放-->
                    <el-table-column min-width="55px" prop="tmSupplierId" :selectable="selectableMethod" type="selection" :label="$t('apply.whetherToIssue')"></el-table-column>
                  </el-table>
                </el-col>
              </el-row>

            </el-form>
          </div>
        </el-form>
      </el-dialog>

      <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
        <SelSupplier :multipleSelectionFlag="false" v-if="SupplierNameDialogReset" ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
      </el-dialog>

      <el-dialog title="以下申请单报价明细的预估年总费用没有维护请维护后再进行结束询价" :visible.sync="showNewErrorDialog" width="660px">
        <!--创建新轮次-->
        <el-card class="box-card">
          <div class="handle-box">
            <el-table sortable :close-on-click-modal="false" :data="errorList" style="width:100%" border highlight-current-row class="table">
              <el-table-column align="center" ali sortable prop="applyNo" label="申请单编号"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { applyService } from "@/api/quotation-apply/quotation-apply";
import { getQuotationListData, roundInit, createNewRound, endQuotation, recoveryQuotation } from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import commonConstatns from "@/constants/commonConstants"
import SelSupplier from '@/components/page/base-data/carrier-sel-page'
import { Message } from "element-ui";
import store from '@/store/index'
import paginationMixin from '../../../../mixins/pagitionMixin';
import { fileService } from "@/api/common/file-utils";
export default {
  name: "inquiryQuotationProduct",
  mixins: [paginationMixin],
  components: {
    SelSupplier
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      activeName: "first",
      SupplierNameDialogReset: false,
      createNewRoundForm: {
        documentNumber: "2"
      },
      dialogVisible: false,
      quotationVisible: false,
      fileList: [],
      isSpecialFreightList: [
        {
          key: "Y",
          label: "是",
        },
        {
          key: "N",
          label: "否",
        }
      ],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        supplierName: null,
        roundStatus: null,
        buyerName: null,
        createDate: null,
        createEndDate: null,
        isSpecialFreight: null,
        eightBitCodesStr: null,
        eightBitCodes: [],
        roundNumber: null,
        tmSupplierId: null,
      },
      roundStatusList: [],
      quotationList: [],
      totalCount: 0,
      labelPosition: 'right',
      applyTypeList: [],
      quotationTypeList: [],

      newRoundHeadData: {},
      supplierList: [],
      newRoundNumber: null,
      ttQuotationApplyId: null,
      roundRemark: '',
      newRoundMCDFlag: true,


      showSaveNewRoundFlag: true,
      fileUploadUrl: commonConstatns.fileUploadUrl,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      uploadFiles: [],
      showNewRoundDialog: false,
      roundRemark: '',
      newRoundNumber: null,
      radioVal: null,
      selectRow: null,
      showSelSupplierDialog: false,
      showNewErrorDialog: false,
      errorList: [],
      multipleSelection: [],
      applyIds: [],
      eightLists: []
    };
  },
  created() {
    this.getInputChoiceValues();
    // this.queryData(1);
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    const eightBitCodesStr = to.meta.reqData.eightBitCodesStr
    let eightBitCodesArr = []
    if (eightBitCodesStr && eightBitCodesStr.length > 0) {
      eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
    }
    const requestData = Object.assign({}, to.meta.reqData)
    requestData.eightBitCodes = eightBitCodesArr
    getQuotationListData(requestData).then((res) => {
      next(vm => {
        vm.queryCondition = requestData;
        vm.quotationList = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    //单选操作
    // getSelectRow: function (row) {
    //   this.selectRow = row;
    // },
    // onChangeClick(val) {
    //   this.eightLists = []
    //   var arr = val.split(/[.]|,/)
    //   for (let i = 0; i < arr.length; i++) {
    //     this.eightLists.push({
    //       aaa: arr[i]
    //     })
    //   }
    // },
    //页面数据查询
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodesStr = this.queryCondition.eightBitCodesStr
      let eightBitCodesArr = []
      if (eightBitCodesStr && eightBitCodesStr.length > 0) {
        eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
      }
      const requestData = Object.assign({}, this.queryCondition)
      this.$set(requestData, 'eightBitCodes', eightBitCodesArr)
      getQuotationListData(requestData).then((res) => {
        this.quotationList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //详情
    openQuotationApplyDetail: function (row) {
      this.$router.push({
        path: `/inquiry-quotation-product-detail`,
        query: {
          applyId: row.ttQuotationApplyRoundId,
          roundStatus: row.roundStatus,
          source: "quotation"
        }
      });
    },

    clearSupplierName() {
      this.queryCondition.supplierName = "";
      this.queryCondition.tmSupplierId = null
      this.SupplierNameDialogReset = false
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true
      })
    },
    //初始化创建新伦次
    showNewRoundDialogFunc: function () {
      let _this = this;
      _this.uploadFiles = [];
      let rows = _this.$refs.quotationDataTable.selection;
      if (rows.length == 0) {
        //请选择需创建新轮次的询价！
        _this.$message({ message: this.$t('apply.selectNewRoundQuote'), type: "warning" });
        return;
      }
      if (rows.length > 1) {
        Message({ message: "创建新轮次只允许进行单一创建，不允许多选!", type: "warning" });
        return;
      }
      let quotation = rows[0];
      if (_this.applyStatusCloseWarning(quotation.status)) { return; }
      if (!quotation.ownerFlag) {
        _this.$message({ message: "只能操作自己名下的单据", type: "warning" });
        return;
      }
      if (!(quotation.roundStatus == '2' && quotation.isLastRound == 'Y')) {
        //只有报价完成且最新轮次才可以进行新轮次创建！
        _this.$message({ message: this.$t('apply.newRoundCondition'), type: "warning" });
        return;
      }
      _this.newRoundNumber = null;
      _this.roundRemark = '';
      _this.ttQuotationApplyId = null;
      roundInit(quotation).then((res) => {
        if (res.quotationApply.source == 'SUP') {//如何申请单是供应商创建的则不可以编辑供应商
          _this.newRoundMCDFlag = false;
        }
        _this.newRoundHeadData = res.quotationApply;
        _this.supplierList = res.supplierList;
        _this.newRoundNumber = res.roundNumber;
        _this.ttQuotationApplyId = res.ttQuotationApplyId;
        _this.showNewRoundDialog = true;
        _this.supplierList.forEach(row => {
          _this.$nextTick(() => {
            _this.supplierList.forEach(row => {
              _this.$refs.supplierListDataTable.toggleRowSelection(row, true);
            })
          })
        })
      })

    },
    //新轮次创建
    saveNewRoundFunc: function () {
      let _this = this;
      //判断是否选择了供应商
      let rows = this.$refs.supplierListDataTable.selection;
      if (rows.length == 0) {
        //请选择需要发放的供应商
        _this.$message({ message: this.$t('apply.selectPublishSupplier'), type: "warning" });
        return;
      }
      this.showSaveNewRoundFlag = false;
      let supIds = [];
      rows.forEach((item) => {
        supIds.push(item.tmSupplierId);
      });
      let quotationInfo = {};
      quotationInfo.roundNumber = this.newRoundNumber;
      quotationInfo.roundRemark = this.roundRemark;
      quotationInfo.supplierIds = supIds;
      quotationInfo.listDoc = this.uploadFiles;
      quotationInfo.ttQuotationApplyId = this.ttQuotationApplyId;
      createNewRound(quotationInfo).then((res) => {
        //_this.radioVal = null;
        // _this.selectRow = null;
        //创建成功
        _this.$message({ message: this.$t('common.createSuccess'), type: "success" });
        _this.$refs.quotationDataTable.clearSelection();
        _this.showNewRoundDialog = false;
        _this.queryData();
        _this.showSaveNewRoundFlag = true;
      }).catch((error) => {
        _this.showSaveNewRoundFlag = true;
      })
    },
    //结束询价，只有报价完成的单据可以结束报价，结束报价后可以进行报价确认操作
    endQuotationFunc: function () {
      let _this = this;
      let rows = _this.$refs.quotationDataTable.selection;
      let ids = [];
      if (rows.length == 0) {
        //请选择需要结束的询价！
        _this.$message({ message: this.$t('apply.selectEndQuote'), type: "warning" });
        return;
      } else {
        for (let index in rows) {
          let rwoData = rows[index];
          if (_this.applyStatusCloseWarning(rwoData.status)) {
            return;
          }
          if (!rwoData.ownerFlag) {
            _this.$message({ message: "只能操作自己名下的单据", type: "warning" });
            return;
          }
          if (rwoData.quotationStatus == '3' && rwoData.roundStatus == '2') {
            _this.$message({ message: "恢复询价后不可进行再继续结束询价!请进行新轮次创建!", type: "warning" });
            return;
          }
          //收集可以结束的报价ID(只有报价完的才可以结束报价)
          if (rwoData.quotationStatus != '2') {
            //请选择报价状态为报价完成的单据进行操作！
            _this.$message({ message: this.$t('apply.selectCompletedQuotationStatus'), type: "warning" });
            return;
          }
          ids.push(rwoData.ttQuotationId);
        }
      }
      endQuotation(ids).then((res) => {
        if (res.meta.success) {
          //_this.selectRow = null;
          //_this.radioVal = null;
          //结束询价成功
          _this.$message({ message: this.$t('apply.closeRFQSuccess'), type: "success" });
          _this.queryData();
        } else {
          if (res.data.length == 1) {
            _this.$message({ message: '报价明细的预估年总费用没有维护请维护后再进行结束询价!', type: "warning" });
            //转到报价详情，让用户维护预估年总费用
            let roundId = res.data[0].roundId;
            this.$router.push({
              path: `/inquiry-quotation-product-detail`,
              query: {
                applyId: roundId,
                from: "eq",
                roundStatus:"2"
              }
            });
          } else {
            _this.errorList = res.data;
            _this.showNewErrorDialog = true;
            //重新获取
            if (ids.length != res.data.length) {
              _this.queryData();
            }
          }
        }
      })
    },
    //恢复询价:只能恢复最新轮次，且轮次状态为结束询价的
    recoveryQuotationFunc: function () {
      let _this = this;
      let rows = _this.$refs.quotationDataTable.selection;
      let ids = [];
      if (rows.length == 0) {
        //请选择需要恢复的询价！
        _this.$message({ message: _this.$t('apply.selectResumeQuote'), type: "warning" });
        return;
      } else if (rows.length > 1) {
        Message({ message: "恢复询价只允许进行单一操作，不允许多选!", type: "warning" });
        return;
      } else {
        let rowData = rows[0];
        if (_this.applyStatusCloseWarning(rowData.status)) { return; }
        if (!rowData.ownerFlag) {
          _this.$message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //收集可以进行恢复报价ID(只有结束报价的才可以恢复报价)
        if (rowData.roundStatus == '3' && rowData.isLastRound == 'Y') {
          ids.push(rowData.ttQuotationId);
        }
        if (ids.length == 0) {
          //只有最新轮次且轮次状态为结束询价的才能进行恢复操作！
          //_this.$t('apply.resumeQuoteCondition')
          _this.$message({ message: '只有最新轮次且轮次状态为询价结束的才能进行恢复操作！', type: "warning" });
          return;
        }
      }
      recoveryQuotation(ids[0]).then((res) => {
        //_this.radioVal = null;
        //_this.selectRow = null;
        //恢复询价成功
        _this.$message({ message: _this.$t('apply.resumeRFQSuccess'), type: "success" });
        _this.queryData();
      })
    },
    onExport() {
      var reqData = Object.assign({}, this.queryCondition)
      this.$set(reqData, 'applyIds', this.applyIds)
      applyService.onExport(reqData).then((res) => {
        fileService.respToFile(res, 'RFQ(Material)Report.xlsx');
      })
    },
    handleSelectionChange(val) {
      this.applyIds = []
      this.multipleSelection = val;
      val.forEach(ele => {
        this.applyIds.push(ele.ttQuotationApplyId)
      })
    },
    //创建报价确认
    createQuoteConfirmation() {
      let _this = this;
      let rows = _this.$refs.quotationDataTable.selection;
      if (rows.length == 0) {
        _this.$message({ message: "请选择需要创建报价确认", type: "warning" });
        return;
      } else if (rows.length > 1) {
        Message({ message: "价格确认只允许进行单一操作，不允许多选!", type: "warning" });
        return;
      }
      let rowData = rows[0];
      if (rowData.roundStatus != 3) {
        Message.error(_this.$t('apply.pleaseSelectQuoteFinishedData'));
        return;
      } else {
        if (_this.applyStatusCloseWarning(rowData.status)) { return; }
        this.$router.push({
          path: `/inquiry-quotation-product-submit`,
          query: {
            ttQuotationId: rowData.ttQuotationId,
          }
        });
      }
    },
    openQuotationHistory: function (applyId) {
      this.$router.push({
        path: `/inquiry-quotation-product-history`,
        query: {
          applyId: applyId,
        }
      });
    },
    selectableMethod: function (row) {
      return this.newRoundMCDFlag;
    },
    //文件上传成功回调
    uploadSuccess: function (response, file, fileList) {
      this.uploadFiles.push(...response.data);
    },

    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"] = "TT_QUOTATION_APPLY_ROUND:ROUND_STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.roundStatusList = res["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"];
        this.quotationStatusList = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusList = res["TT_SOURCING:STATUS"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },
    applyStatusCloseWarning: function (status) {
      let _this = this;
      if (status == '3') {
        _this.$message({ message: "此单据号为作废状态，无法操作！", type: "warning" });
        return true;
      }
      return false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList) {
      console.log(fileList);
      this.fileList = fileList.slice(-1);
    },
    handleClose() {
      this.dialogVisible = false;
      this.quotationVisible = false;
    },
    checkRoundNumber: function (val) {
      if (undefined != val) {
        let reg = /^(0|[1-9]\d{0,9})$/;
        if (!reg.test(val)) {
          this.queryCondition.roundNumber = 1;
        }
      }
    },
    selectSupplierMethod: function (supList) {
      this.queryCondition.supplierName = supList[0].supplierName;
      this.queryCondition.tmSupplierId = supList[0].tmSupplierId;
      this.showSelSupplierDialog = false;
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        supplierName: null,
        roundStatus: null,
        buyerName: null,
        createDate: null,
        createEndDate: null,
        isSpecialFreight: null,
        eightBitCodesStr: null,
        eightBitCodes: [],
        roundNumber: null,
        tmSupplierId: null,
      }
      this.$refs.quotationDataTable.clearSelection();
      this.queryData()
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.inquiryQuotationProduct {
  .toolsBox {
    margin-bottom: 10px;
  }
  .btnsWarp {
    text-align: right;
    margin-top: 20px;
  }
  .dialogIntable {
    margin-top: 20px;
  }
  .a-link {
    text-decoration: underline;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
